import React from "react";
import {
    Box,
    Card,
    CardContent,
    Typography,
    TextField,
    InputAdornment
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const SearchableUserList = ({
    users = [],
    searchValue = '',
    onSearchChange,
    placeholder = 'Search users...',
    title,
    subtitle,
    renderUser,
    dropRef,
    minHeight = 80,
    maxHeight = 300,
    cardSx = {},
    emptyMessage = 'No users found',
    showSearch = true,
    customHeader
}) => {
    return (
        <Card
            ref={dropRef}
            sx={cardSx}
        >
            <CardContent>
                {customHeader ? (
                    customHeader
                ) : (
                    <>
                        {title && (
                            <Typography variant="h6" gutterBottom>
                                {title}
                            </Typography>
                        )}
                        {subtitle && (
                            <Typography variant="body2" color="text.secondary" gutterBottom>
                                {subtitle}
                            </Typography>
                        )}
                    </>
                )}
                {showSearch && (
                    <TextField
                        size="small"
                        fullWidth
                        placeholder={placeholder}
                        value={searchValue}
                        onChange={(e) => onSearchChange(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                        sx={{ mb: 2 }}
                    />
                )}
                <Box sx={{
                    minHeight: minHeight,
                    maxHeight: maxHeight,
                    overflowY: 'auto',
                    overflowX: 'hidden'
                }}>
                    {users.map(user => (
                        <Box key={user.user_sub || user.sub} sx={{ mb: 0.25 }}>
                            {renderUser(user)}
                        </Box>
                    ))}
                    {users.length === 0 && (
                        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 2 }}>
                            {emptyMessage}
                        </Typography>
                    )}
                </Box>
            </CardContent>
        </Card>
    );
};

export default SearchableUserList;
